/**
 * Full model lab catalog, sorted by display name and assembled from the
 * alphabetical chunks.
 *
 * Generated by `pnpm logos:sync`; see `../model-labs.ts`.
 */
import { LABS_0_C } from './labs-0-c.js';
import { LABS_D_L } from './labs-d-l.js';
import { LABS_M_R } from './labs-m-r.js';
import { LABS_S_Z } from './labs-s-z.js';
export const MODEL_LABS = [...LABS_0_C, ...LABS_D_L, ...LABS_M_R, ...LABS_S_Z];
//# sourceMappingURL=catalog.js.map